import { useContext, useState, useEffect } from "react";
import MunicipioContext from "../../src/context/MunicipiosContext";

export default function useObtenerMunicipio(munUrl) {
  const { municipios } = useContext(MunicipioContext);
  const [municipio, guardarMunicipio] = useState(undefined);
  const [error, guardarError] = useState(false);

  useEffect(() => {
    if (municipios.length > 0) {
      const munFiltrado = municipios.filter((m) => m.nombreUrl === munUrl)[0];
      if (munFiltrado) {
        guardarMunicipio(munFiltrado);
      } else {
        guardarError(true);
      }
    }
    return () => {
      guardarMunicipio(undefined);
      guardarError(false);
    };
  }, [municipios, munUrl]);

  return [municipio, error];
}
